<template>
    <el-dialog :visible.sync="dialogVisible" :title="$t('addRoute.selectApiTitle')" width="70%">

        <!-- 新增查询表单 -->
        <el-form :inline="true" :model="searchForm" class="search-form">
            <el-form-item :label="$t('service.table.serviceCode')">
                <el-input v-model="searchForm.serviceCode" :placeholder="$t('service.table.serviceCode')"
                    clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('service.table.name')">
                <el-input v-model="searchForm.name" :placeholder="$t('service.table.name')" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch">{{ $t('common.search') }}</el-button>
            </el-form-item>
        </el-form>

        <el-table ref="serviceTable" v-loading="loading" :data="tableData" :row-key="getRowKey" border
            style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" reserve-selection></el-table-column>
            <el-table-column :label="$t('service.table.serviceCode')" prop="serviceCode"></el-table-column>
            <el-table-column :label="$t('service.table.name')" prop="name"></el-table-column>
            <el-table-column :label="$t('service.table.serviceId')" prop="serviceId"></el-table-column>
            <el-table-column :label="$t('service.table.url')" prop="url"></el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
                layout="total, sizes, prev, pager, next, jumper" :total="page.total"></el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
            <span class="selected-count">{{ $t('addRoute.selectedCount', { count: selectedServices.length }) }}</span>
            <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
            <el-button type="primary" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getServiceList } from '@/api/dev/serviceApi'

export default {
    name: 'SelectService',
    data() {
        return {
            page: {
                current: 1,
                size: 10,
                total: 0
            },
            tableData: [],
            loading: false,
            selectedServices: [],
            selectedServiceMap: {},
            syncingSelection: false,
            dialogVisible: false,
            searchForm: {
                serviceCode: '',
                name: ''
            }
        }
    },
    created() { },
    methods: {
        openDialog(selectedServices = []) {
            this.selectedServices = selectedServices.slice();
            this.selectedServiceMap = selectedServices.reduce((result, service) => {
                result[service.serviceId] = service;
                return result;
            }, {});
            this.dialogVisible = true;
            this._loadApiList();
        },
        getRowKey(row) {
            return row.serviceId;
        },
        async _loadApiList() {
            this.loading = true
            try {
                const params = {
                    page: this.page.current,
                    row: this.page.size,
                    ...this.searchForm  // 将搜索条件合并到请求参数
                }
                const { services, total } = await getServiceList(params);
                this.tableData = services;
                this.page.total = total;
                this.$nextTick(this.restorePageSelection);
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },
        handleSelectionChange(selection) {
            if (this.syncingSelection) {
                return;
            }
            this.tableData.forEach(service => {
                delete this.selectedServiceMap[service.serviceId];
            });
            selection.forEach(service => {
                this.selectedServiceMap[service.serviceId] = service;
            });
            this.selectedServices = Object.keys(this.selectedServiceMap).map(serviceId => {
                return this.selectedServiceMap[serviceId];
            });
        },
        restorePageSelection() {
            this.syncingSelection = true;
            this.$refs.serviceTable.clearSelection();
            this.tableData.forEach(service => {
                if (this.selectedServiceMap[service.serviceId]) {
                    this.$refs.serviceTable.toggleRowSelection(service, true);
                }
            });
            this.syncingSelection = false;
        },
        handleConfirm() {
            this.$emit('select', this.selectedServices.slice());
            this.dialogVisible = false;
        },
        handleSizeChange(val) {
            this.page.size = val;
            this._loadApiList();
        },
        handleCurrentChange(val) {
            this.page.current = val;
            this._loadApiList();
        },
        handleSearch() {
            this.page.current = 1; // 搜索时重置页码
            this._loadApiList();
        }
    }
};
</script>

<style scoped>
:deep(.el-dialog__header) {
    text-align: left;
}

:deep(.el-dialog__body) {
    padding-top: 10px
}

.search-form {
    text-align: right;
}

.dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.selected-count {
    margin-right: auto;
    color: #606266;
}
</style>
